import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data/site";

export const BrandMarquee = () => {
  return (
    <section
      className="border-y border-gray-200 bg-white py-8 sm:py-10"
      data-testid="brand-marquee"
      aria-hidden="true"
    >
      <Marquee speed={38} gradient gradientColor="#ffffff" gradientWidth={120}>
        {MARQUEE_ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="mx-8 sm:mx-12 font-heading font-extrabold tracking-tight text-4xl sm:text-6xl text-outline">
              {item}
            </span>
            <span className="h-3 w-3 rounded-full bg-brand-accent" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
